// TODO: change the code to the new ong's code
export default {
  code: 'MSF',
  imgLogo: 'img/solidarity/ong/entreculturas/logo_entreculturas.jpg',
  imgDetails: 'img/solidarity/ong/entreculturas/PA240359.jpg',
  link: 'https://www.redec.es/es/redec/red-solidaria-de-jovenes',
  linkText: 'www.redec.es',
  moreInformation:'Más información:',
  description: [
    {thin:'SOLIDARITY.ONGS.ENTRECULTURAS.PARAGRAPH1'},
    {thick:'SOLIDARITY.ONGS.ENTRECULTURASTHICK.PARAGRAPH2',thin:'SOLIDARITY.ONGS.ENTRECULTURAS.PARAGRAPH2'},
    {thick:'SOLIDARITY.ONGS.ENTRECULTURASTHICK.PARAGRAPH3',thin:'SOLIDARITY.ONGS.ENTRECULTURAS.PARAGRAPH3'},
    {thick:'SOLIDARITY.ONGS.ENTRECULTURASTHICK.PARAGRAPH4',thin:'SOLIDARITY.ONGS.ENTRECULTURAS.PARAGRAPH4'},
    {thin:'SOLIDARITY.ONGS.ENTRECULTURAS.PARAGRAPH5'},
  ]
};



// WEBPACK FOOTER //
// ./client/app/solidarity.module/common/services/static/ongs.data.msf.js